export default __webpack_public_path__ + "static/media/mlbs.841cda63.png";